import {Box, Button, Typography} from '@mui/material';
import {useEffect} from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import {useTranslation} from 'react-i18next';

export default function ConfirmDoneStep({resetFormDataAndGoToFirstStep}) {
  const {t} = useTranslation();

  useEffect(() => {
    const resetTimeout = setTimeout(resetFormDataAndGoToFirstStep, 5000);

    return () => {
      clearTimeout(resetTimeout);
    };
  }, []);

  function onOk(e) {
    e.preventDefault();
    resetFormDataAndGoToFirstStep();
  }

  return (
    <div>
      <Typography variant="h2" gutterBottom marked="center" align="center">
        {t('confirm-done-page-title')}
      </Typography>

      <Box component="form" onSubmit={onOk} sx={{mt: 6}}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography>{t('confirmation-done-text')}</Typography>
            <Button fullWidth type="submit">{t('ok-button')}</Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
ConfirmDoneStep.propTypes = {
  resetFormDataAndGoToFirstStep: PropTypes.func.isRequired,
};

